/* eslint-disable func-names */
import * as Yup from 'yup';

const requiredMsg = 'Required!';

export default Yup.object().shape({
  email: Yup.string().required(requiredMsg),
  password: Yup.string().required(requiredMsg),
});
